import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
export const NotFound = (): React.ReactElement => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-gradient-to-r from-blue-400 to-purple-500 dark:from-blue-800 dark:to-purple-900">
            <div className="w-64 h-64 mb-8">
                <p>Not found</p>
            </div>
            <div className="text-center bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg">
                <h2 className="text-4xl font-bold mb-4 text-gray-800 dark:text-white">
                    {t('404Title')}
                </h2>
                <p className="text-xl mb-8 text-gray-600 dark:text-gray-300">
                    {t('404Message')}
                </p>
                <Link
                    to="/"
                    className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded transition duration-300"
                >
                    {t('backToHome')}
                </Link>
            </div>
        </div>
    )
}
